// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type NetworkQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type NetworkQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    networkTransmit?: Array<Array<number | null> | null> | null;
    networkReceive?: Array<Array<number | null> | null> | null;
  } | null;
};

export const NetworkDocument = gql`
  query Network($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      networkTransmit
      networkReceive
    }
  }
`;

/**
 * __useNetworkQuery__
 *
 * To run a query within a React component, call `useNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useNetworkQuery(
  baseOptions: Apollo.QueryHookOptions<NetworkQuery, NetworkQueryVariables> &
    ({ variables: NetworkQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NetworkQuery, NetworkQueryVariables>(
    NetworkDocument,
    options,
  );
}
export function useNetworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NetworkQuery,
    NetworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NetworkQuery, NetworkQueryVariables>(
    NetworkDocument,
    options,
  );
}
// @ts-ignore
export function useNetworkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NetworkQuery,
    NetworkQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<NetworkQuery, NetworkQueryVariables>;
export function useNetworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  NetworkQuery | undefined,
  NetworkQueryVariables
>;
export function useNetworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NetworkQuery, NetworkQueryVariables>(
    NetworkDocument,
    options,
  );
}
export type NetworkQueryHookResult = ReturnType<typeof useNetworkQuery>;
export type NetworkLazyQueryHookResult = ReturnType<typeof useNetworkLazyQuery>;
export type NetworkSuspenseQueryHookResult = ReturnType<
  typeof useNetworkSuspenseQuery
>;
export type NetworkQueryResult = Apollo.QueryResult<
  NetworkQuery,
  NetworkQueryVariables
>;
